import React from 'react'
// @ts-ignore
import { Tooltip } from '@netbasequid/core'
import styled from 'styled-components'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
import ActionIcon from './ActionIcon'

type ActionIconsContainerProps = {
  children: React.ReactElement
  message: string
  url?: string
  callback?: () => void
  tooltipContent: string
}

const StyledActionIconLink = styled.a`
  color: ${({ mode }: { mode: Theme }) => sys[mode].interaction.primary.default};
  white-space: nowrap;
  font-size: 14px;
  line-height: 22px;
  text-decoration: none;
`

const ActionIconsContainer = ({
  tooltipContent,
  children,
  message,
  url,
  callback
}: ActionIconsContainerProps) => {
  const theme = useDisplayTheme() as Theme

  const handleCallback = (event: React.MouseEvent) => {
    event.stopPropagation()
    if (callback) {
      callback()
    }
  }

  return url ? (
    <Tooltip mode={theme} enabled={!message} content={tooltipContent}>
      <StyledActionIconLink
        href={url}
        target="_blank"
        rel="noreferrer"
        onClick={handleCallback}
        mode={theme}>
        <ActionIcon message={message}>{children}</ActionIcon>
      </StyledActionIconLink>
    </Tooltip>
  ) : (
    <Tooltip mode={theme} enabled={!message} content={tooltipContent}>
      <ActionIcon message={message}>{children}</ActionIcon>
    </Tooltip>
  )
}

export default ActionIconsContainer
